var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{attrs:{"flat":""}},[_c('Title',{attrs:{"title":"anagrafica"}}),_c('p',[_vm._v("L'applicazione anagrafica non utilizza i tabs")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }